<div class="store-locator-page">
  <div class="container-fluid py-4">
    <!-- Page Header -->
    <div class="page-header mb-4">
      <h1><i class="fa fa-map-marker-alt me-2"></i>{{ 'storeLocator.title' | translate }}</h1>
      <p class="text-muted">{{ 'storeLocator.subtitle' | translate }}</p>
    </div>

    <div class="store-locator-container">
      <!-- Sidebar -->
      <div class="store-sidebar">
        <!-- Search -->
        <div class="search-box mb-4">
          <div class="input-group">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              [placeholder]="'storeLocator.searchPlaceholder' | translate"
              [(ngModel)]="searchQuery"
              (input)="onSearchChange()"
            />
          </div>
        </div>

        <!-- Brand Filters -->
        <div class="brand-filters mb-4">
          <div class="filter-header d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">{{ 'storeLocator.filterByBrand' | translate }}</h5>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-outline-primary btn-xs" (click)="selectAllBrands()">{{ 'storeLocator.all' | translate }}</button>
              <button class="btn btn-outline-secondary btn-xs" (click)="clearBrandSelection()">{{ 'storeLocator.none' | translate }}</button>
            </div>
          </div>
          @for (brand of brands; track brand.brand_id) {
            <label class="brand-filter-item" [class.selected]="isBrandSelected(brand.brand_id)">
              <input
                type="checkbox"
                [checked]="isBrandSelected(brand.brand_id)"
                (change)="toggleBrand(brand.brand_id)"
              />
              <span class="brand-color" [style.background]="brand.brand_color"></span>
              <span class="brand-name">{{ brand.brand_name }}</span>
              <span class="location-count">({{ brand.location_count }})</span>
            </label>
          }
        </div>

        <!-- Store List -->
        <div class="store-list">
          <h5 class="mb-3">{{ filteredLocations.length }} {{ 'storeLocator.storesFound' | translate }}</h5>
          @if (loading) {
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
              </div>
            </div>
          } @else if (filteredLocations.length === 0) {
            <div class="empty-state">
              <i class="fa fa-store-slash fs-3 text-muted mb-2"></i>
              <p class="text-muted">{{ 'storeLocator.noStoresFound' | translate }}</p>
            </div>
          } @else {
            @for (location of filteredLocations; track location.location_id) {
              <div
                class="store-card"
                [id]="'store-card-' + location.location_id"
                [class.selected]="selectedLocation?.location_id === location.location_id"
                (click)="selectLocation(location)"
              >
                <div class="store-brand-badge" [style.background]="location.brand_color">
                  {{ location.brand_name }}
                </div>
                <h6 class="store-name">{{ location.store_name }}</h6>
                <p class="store-address text-muted mb-2">{{ location.address }}</p>

                @if (location.rating) {
                  <div class="store-rating mb-2">
                    <i class="fa fa-star text-warning me-1"></i>
                    <span>{{ location.rating }}</span>
                    @if (location.total_ratings) {
                      <span class="text-muted">({{ location.total_ratings }})</span>
                    }
                  </div>
                }

                <div class="store-actions">
                  @if (location.phone) {
                    <button class="btn btn-sm btn-outline-secondary" (click)="callPhone(location.phone); $event.stopPropagation()">
                      <i class="fa fa-phone"></i>
                    </button>
                  }
                  @if (location.website) {
                    <button class="btn btn-sm btn-outline-secondary" (click)="openWebsite(location.website); $event.stopPropagation()">
                      <i class="fa fa-globe"></i>
                    </button>
                  }
                  <button class="btn btn-sm btn-primary" (click)="getDirections(location); $event.stopPropagation()">
                    <i class="fa fa-directions me-1"></i>{{ 'storeLocator.directions' | translate }}
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </div>

      <!-- Map -->
      <div class="map-container">
        <app-location-map
          [markers]="mapMarkers"
          [config]="mapConfig"
          [loading]="loading"
          (markerClick)="onMapMarkerClick($event)"
          (infoWindowAction)="onInfoWindowAction($event)"
        ></app-location-map>
      </div>
    </div>
  </div>
</div>
